import { normalizeIban } from "./partyCountry.helpers";

// Bank fields of a party; any change means the parties must be re-saved.
const bankKey = (party) =>
  [
    normalizeIban(party?.iban),
    party?.bankCountry || "",
    party?.bankName || "",
    party?.swiftCode || "",
    party?.bankBranchName || "",
    party?.bankDocument?.objectName || "",
  ].join("|");

export function milestonePartiesEqual(backendParties, frontEndParties) {
  if (backendParties?.length !== frontEndParties?.length) {
    return false;
  }

  return backendParties?.every((party) => {
    const isBroker = party?.role === "BROKER";

    const frontEndParty = isBroker
      ? frontEndParties?.find((frontParty) => frontParty?.role === "BROKER")
      : frontEndParties?.find(
          (frontParty) => frontParty?.phoneNumber === party?.phoneNumber
        );

    const identityMatches = isBroker
      ? frontEndParty?.role === "BROKER"
      : party?.phoneNumber === frontEndParty?.phoneNumber;

    return (
      party?.amount === frontEndParty?.amount &&
      identityMatches &&
      (party?.nationalAddress || "") ===
        (frontEndParty?.nationalAddress || "") &&
      bankKey(party) === bankKey(frontEndParty) &&
      (party?.companyName || "") === (frontEndParty?.companyName || "") &&
      (party?.companyUnifiedNumber || "") ===
        (frontEndParty?.companyUnifiedNumber || "")
    );
  });
}
